module.exports = __webpack_public_path__ + "static/media/屏幕模块.2a4b1d07.png";